// Kész Házak modellek adatai - HH előtaggal
export const keszHazakModels = [
  {
    "title": "HH Lucara",
    "slug": "lucara",
    "price_from_eur": 75999,
    "area_m2": 135.11,
    "hero_images": ["lucara-1.jpg", "lucara-2.jpg", "lucara-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Modern bungaló kényelmes családi élethez.",
    "highlights": [
      "Egyszintes, praktikus elrendezés",
      "Tágas nappali-konyha-étkező",
      "Fedett terasz opció"
    ],
    "description": [
      "A középméretű kategóriánk kényelmes, egy szinten szervezett életteret ad 4–5 fős családnak.",
      "A nappali a konyhával és étkezővel egy légtérben, levegős, világos központi térrel.",
      "Modern bungaló a kényelmes családi élethez. A nappali egybenyitott konyhával és étkezővel tágas, levegős központi teret ad."
    ],
    "floorplan_image": "lucara-floor.png",
    "cta_primary": "Érdekel az ajánlat",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 30,
      "example_rate_percent": 3.86
    },
    "seo": {
      "meta_title": "HH Lucara – Kész Ház | HoppHomes",
      "meta_description": "Modern bungaló 135,11 m²-től, ártól 75 999 € – kényelmes családi otthon.",
      "og_image": "lucara-1.jpg"
    },
    "note": "Alapkivitel illusztratív; végleges műszaki tartalom árajánlatban."
  },
  {
    "title": "HH Nativi",
    "slug": "nativi",
    "price_from_eur": 72999,
    "area_m2": 161.02,
    "hero_images": ["nativi-1.jpg", "nativi-2.jpg", "nativi-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Családoknak tervezett, tágas egyszintes otthon.",
    "highlights": [
      "Praktikus közlekedő",
      "Elkülöníthető hálózóna",
      "Nagy nappali"
    ],
    "description": [
      "Családoknak tervezett, tágas egyszintes otthon, modern arányokkal és jól tagolt közösségi/privát terekkel.",
      "A praktikus közlekedő és az elkülöníthető hálózóna biztosítja a családtagok kényelmét.",
      "Nagy nappali tér a közös családi pillanatokhoz."
    ],
    "floorplan_image": "nativi-floor.png",
    "cta_primary": "Kérek konzultációt",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 30,
      "example_rate_percent": 3.86
    },
    "seo": {
      "meta_title": "HH Nativi – Kész Ház | HoppHomes",
      "meta_description": "Tágas családi ház 161,02 m²-től, ártól 72 999 € – modern arányokkal.",
      "og_image": "nativi-1.jpg"
    },
    "note": "Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ."
  },
  {
    "title": "HH Martino",
    "slug": "martino",
    "price_from_eur": 69999,
    "area_m2": 146.37,
    "hero_images": ["martino-1.jpg", "martino-2.jpg", "martino-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Kiegyensúlyozott alaprajz, családbarát terek.",
    "highlights": [
      "Világos nappali",
      "Hatékony tárolás",
      "Opciós terasz"
    ],
    "description": [
      "Kiegyensúlyozott alaprajz, családbarát terek. A fedett terasz pihenésre és kinti étkezésre is alkalmas.",
      "A világos nappali és a hatékony tárolási megoldások praktikus otthont biztosítanak.",
      "Az opciós terasz lehetőséget ad a szabadtéri kikapcsolódásra."
    ],
    "floorplan_image": "martino-floor.png",
    "cta_primary": "Érdekel az ajánlat",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 30,
      "example_rate_percent": 3.86
    },
    "seo": {
      "meta_title": "HH Martino – Kész Ház | HoppHomes",
      "meta_description": "Családbarát ház 146,37 m²-től, ártól 69 999 € – fedett terasz opcióval.",
      "og_image": "martino-1.jpg"
    },
    "note": "Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ."
  },
  {
    "title": "HH Verona",
    "slug": "verona",
    "price_from_eur": 59999,
    "area_m2": 97.97,
    "hero_images": ["verona-1.jpg", "verona-2.jpg", "verona-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Kompakt, mégis kényelmes bungaló modern vonalakkal.",
    "highlights": [
      "Gyors kivitelezhetőség",
      "Költséghatékony üzemeltetés",
      "Modern vonalak"
    ],
    "description": [
      "Kompakt, mégis kényelmes bungaló modern vonalakkal – fiatal családoknak ideális.",
      "A gyors kivitelezhetőség és költséghatékony üzemeltetés teszi vonzóvá ezt a modellt.",
      "Modern vonalak és praktikus elrendezés jellemzi."
    ],
    "floorplan_image": "verona-floor.png",
    "cta_primary": "Érdekel az ajánlat",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 30,
      "example_rate_percent": 3.86
    },
    "seo": {
      "meta_title": "HH Verona – Kész Ház | HoppHomes",
      "meta_description": "Kompakt bungaló 97,97 m²-től, ártól 59 999 € – fiatal családoknak ideális.",
      "og_image": "verona-1.jpg"
    },
    "note": "Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ."
  },
  {
    "title": "HH Kate",
    "slug": "kate",
    "price_from_eur": 49999,
    "area_m2": 99.22,
    "hero_images": ["kate-1.jpg", "kate-2.jpg", "kate-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Letisztult, praktikus elrendezésű otthon.",
    "highlights": [
      "Okos tárolók",
      "Egyszerű építés",
      "Barátságos költségek"
    ],
    "description": [
      "Letisztult, praktikus elrendezésű otthon, intelligensen kihasznált terekkel.",
      "Az okos tárolók és egyszerű építési megoldások költséghatékony otthont biztosítanak.",
      "Barátságos költségekkel elérhető családi ház."
    ],
    "floorplan_image": "kate-floor.png",
    "cta_primary": "Érdekel az ajánlat",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 30,
      "example_rate_percent": 3.86
    },
    "seo": {
      "meta_title": "HH Kate – Kész Ház | HoppHomes",
      "meta_description": "Praktikus otthon 99,22 m²-től, ártól 49 999 € – okos tárolókkal.",
      "og_image": "kate-1.jpg"
    },
    "note": "Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ."
  },
  {
    "title": "Garázs Thomas",
    "slug": "garazs-thomas",
    "price_from_eur": 11999,
    "area_m2": 22.42,
    "hero_images": ["thomas-1.jpg", "thomas-2.jpg", "thomas-3.jpg"],
    "status_badge": "Aktuálisan elérhető",
    "short_tagline": "Modern, többcélú garázs.",
    "highlights": [
      "Gyors telepítés",
      "Bővíthető funkciók",
      "Biztonságos tárolás"
    ],
    "description": [
      "Modern, többcélú garázs – biztonságos tárolás járműnek és kerti eszközöknek.",
      "A gyors telepítés és bővíthető funkciók praktikus megoldást nyújtanak.",
      "Biztonságos tárolási lehetőség járművek és kerti eszközök számára."
    ],
    "floorplan_image": "thomas-floor.png",
    "cta_primary": "Érdekel az ajánlat",
    "cta_secondary": "Videóvizualizáció",
    "mortgage": {
      "example_term_years": 15,
      "example_rate_percent": 4.2
    },
    "seo": {
      "meta_title": "Garázs Thomas – Kész Garázs | HoppHomes",
      "meta_description": "Modern garázs 22,42 m²-től, ártól 11 999 € – gyors telepítéssel.",
      "og_image": "thomas-1.jpg"
    },
    "note": "Az ár tájékoztató jellegű, a végleges ár a választott műszaki tartalomtól és helyszíntől függ."
  }
];

// Segédfüggvények
export const getModelBySlug = (slug) => {
  return keszHazakModels.find(model => model.slug === slug);
};

export const getModelsByPriceRange = (minPrice, maxPrice) => {
  return keszHazakModels.filter(model => 
    model.price_from_eur >= minPrice && model.price_from_eur <= maxPrice
  );
};

export const getModelsByType = (type) => {
  if (type === 'bungalo') {
    return keszHazakModels.filter(model => !model.slug.includes('garazs'));
  }
  if (type === 'garazs') {
    return keszHazakModels.filter(model => model.slug.includes('garazs'));
  }
  return keszHazakModels;
};

// Árak formázása
export const formatPrice = (price) => {
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

// Terület formázása
export const formatArea = (area) => {
  return `${area.toFixed(2)} m²`;
};
